import React, { useState, useEffect } from 'react';
import {
  Typography,
  TextField,
  Modal,
  Backdrop,
  Fade,
  Box,
  FormControlLabel,
  Checkbox,
  makeStyles,
} from '@material-ui/core';
import fontFamily from '../../../assets/css/fonts';
import color from '../../../assets/css/colors';
import SelectEntryType from '../../../components/AutoComplete/SelectEntryType';
import { dateProtoObjectToString } from '../../../services/ConvertService';
import Button from '../../../components/Buttons/Button';
import CloseButton from '../../../components/Buttons/CloseButton';
import Text from '../../../components/Typography/Text';

const useStyles = makeStyles(() => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: 800,
    width: '100%',
    margin: '0 auto',
    float: 'clear',
  },
  modalHeader: {
    backgroundColor: 'white',
    padding: 25,
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    display: 'flex',
    '& div:nth-child(1)': {
      flex: 1,
    },
    '& div:nth-child(2)': {
      flex: 'none',
      '& .MuiIconButton-root': {
        borderRadius: 5,
        padding: 10,
        '&:hover svg path': {
          fill: color.primary.main,
        },
      },
      '& svg:last-child': {
        width: 15,
        height: 15,
      },
    },
  },
  modalBody: {
    backgroundColor: 'white',
    padding: '0px 25px 25px 25px',
    fontFamily: fontFamily.headers,
    '& p': {
      fontSize: 16,
      lineHeight: '24px',
    },
  },
  modalFooter: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    backgroundColor: 'white',
    padding: '0px 25px 25px 25px',
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,
    position: 'relative',
    '& button': {
      width: 'auto',
    },
  },
  closeButton: {
    '& button': {
      marginTop: '-4px !important',
    },
  },
}));

export default function PositionOptionModal({
  onClose: handleClose,
  open: isOpen,
  value,
  loading,
}) {
  const classes = useStyles();
  const [modalData, setModalData] = useState({});

  // console.log(modalData);

  console.log(modalData.expirationDate);

  useEffect(() => {
    if (isOpen) {
      let modalValue = { ...value };
      modalValue.expirationDate = dateProtoObjectToString(value.expirationDate);
      setModalData(modalValue);
      // setModalData(value);
    }
  }, [isOpen, value]);

  const handleChange = (e, checkboxValue) => {
    const input = e.currentTarget.name ? e.currentTarget : e.target;
    setModalData({
      ...modalData,
      [input.name]:
        checkboxValue === true || checkboxValue === false ? checkboxValue : input.value,
    });
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={isOpen}
      onClose={() => handleClose()}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 500 }}
    >
      <Fade in={isOpen}>
        <div style={{ width: 800 }}>
          <div className={classes.modalHeader}>
            <div>
              <Text
                mt={4}
                id="transition-modal-title"
                variant="h2"
                label={'Edit Position Mngt'}
              />
            </div>
            <div className={classes.closeButton}>
              <CloseButton onClick={() => handleClose()} />
            </div>
          </div>
          <div className={classes.modalBody}>
            <div className="grd-row nm">
              <div className="grd-cell">
                <TextField
                  fullWidth
                  required
                  name="expirationDate"
                  label="Expiration Date"
                  type="date"
                  value={modalData.expirationDate}
                  onChange={handleChange}
                  InputLabelProps={{ shrink: true }}
                />
              </div>
              <div className="grd-cell">
                <SelectEntryType
                  freeSolo={true}
                  name="entryType"
                  label="Entry Type"
                  value={modalData.entryType}
                  onChange={handleChange}
                ></SelectEntryType>
              </div>
            </div>
            <div className="grd-row">
              <div className="grd-cell">
                <TextField
                  fullWidth
                  required={true}
                  name="qty"
                  label="Qty"
                  type="number"
                  value={modalData.qty}
                  onChange={handleChange}
                  InputLabelProps={{ shrink: true }}
                />
              </div>
              <div className="grd-cell"></div>
            </div>
          </div>
          <div className={classes.modalFooter}>
            <Button
              disabled={loading}
              loading={loading}
              label={loading ? 'Saving...' : 'Save'}
              onClick={() => handleClose(modalData)}
            />
          </div>
        </div>
      </Fade>
    </Modal>
  );
}
